import React from "react"
import Icon from "../Icon/Icon"
import {IcomoonIconName} from "../Icon/icons"
import Skeleton from "react-loading-skeleton"
import {InterestFormulaBox} from "../InterestFormulaBox/InterestFormulaBox"

export interface InterestRateItemProps {
	icon?: IcomoonIconName
	title?: string
	value?: string | number
	additionalInfo?: string
}

export interface InterestFormulaItemProps {
	icon?: IcomoonIconName
	title?: string
	interestFormula: string
	fedLowerBound: number
	fedUpperBound: number
}
export const InterestItem = ({icon, title, value, additionalInfo}: InterestRateItemProps) => (
	<div className="interest-rate-item">
		<div className="interest-rate-item-title-container">
			{icon && <Icon icon={icon} size={20} />}
			{title ? <span> {title} </span> : <Skeleton />}
		</div>
		<div className="interest-rate-item-value-container">{value ? <span>{value}</span> : <Skeleton />}</div>
		<div className="interest-rate-item-additional-info-container">
			{additionalInfo ? <span>{additionalInfo}</span> : <Skeleton />}
		</div>
	</div>
)

export const InterestFormulaItem = ({
	title,
	interestFormula,
	fedLowerBound,
	fedUpperBound,
}: InterestFormulaItemProps) => (
	<div className="interest-formula-item">
		<div className="interest-rate-item-title-container">{title ? <span> {title} </span> : <Skeleton />}</div>
		<InterestFormulaBox interestFormula={interestFormula} fedLowerBound={fedLowerBound} fedUpperBound={fedUpperBound} />
	</div>
)
